import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { GlobalMatch } from "./routes";

export default store => ({
  path: "timetable-manager",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import("./components"),
      import("./modules/TimetableManagerV2Module"),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const reducer = importedModule1.default;
      injectReducer(store, {
        key: "timetableManagerV2",
        reducer,
      });
      return component;
    })
  ),
  childRoutes: [GlobalMatch(store)],
});
